import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
  signal,
  OnInit,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CompanyApi } from '@app/services/company-api';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TypeOptions } from '@app/interface/savedproduct';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { SavedProductInterface } from '@app/interface/savedproduct';
import { SavedProductsApi } from '@app/services/savedproducts-api.service';
import { RecursiveInterface } from '@app/services/base-authenticated.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-savedproduct-details',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    BackHeaderComponent,
    ReactiveFormsModule,
    MatSelectModule,
    MatIconModule,
  ],
  templateUrl: './savedproduct-details.component.html',
  styleUrl: './savedproduct-details.component.scss',
})
export class SavedproductDetailsComponent implements OnInit {
  productId: number;
  productForm: FormGroup;

  typeOptions: TypeOptions[] = [
    { code: 'SERVIZIO', name: 'Servizio' },
    { code: 'PRODOTTO', name: 'Prodotto' },
  ];

  constructor(
    private snackBar: MatSnackBar,
    private SavedProductApi: SavedProductsApi,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {
    this.productForm = this.fb.group({
      id: 1,
      name: '',
      units: '',
      type: 'SERVIZIO',
      unit_price: 0,
      description: '',
      iva_percentage: [{ value: 0, disabled: true }],

      organization_id: -1,
    });

    this.productId = +this.route.snapshot.params['id'];
  }

  ngOnInit() {
    this.loadSavedProducts();

    // Initialize filteredOptions after companies are loaded
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   debounceTime(300),
    //   map((value: any) => this._filter(value || ''))
    // );
  }

  private loadSavedProducts() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.SavedProductApi.getAllSavedProducts<SavedProductInterface>(
      organization_id,
      {},
    ).subscribe({
      next: (response: RecursiveInterface<SavedProductInterface>) => {
        if (response.completed) {
          const product = response.results.find((c) => c.id === this.productId);

          if (product) {
            this.productForm.patchValue({
              ...product,
              organization_id: organization_id,
            });
          } else {
            throw new Error('Company not found');
          }

          console.log('All products loaded');
        } else {
          // Optional: Show loading progress
          console.log(
            `Loaded ${response.results.length} saved products so far...`,
          );
        }
      },
      error: (err: any) => {
        console.error('Error loading products:', err);
        this.showErrorMessage(
          'Errore durante il caricamento prodotti e servizi.',
        );
      },
    });
  }

  onSubmit(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (this.productForm.valid) {
      // where you call the update method
      this.SavedProductApi.updateSavedProductDetails(
        organization_id,
        this.productId,
        this.productForm.value,
      ).subscribe({
        next: (updatedProduct) => {
          this.showSuccessMessage('Prodotto aggiornato con successo!');
          // navigate back to the list
          this.onCancel();
        },
        error: (err: any) => {
          console.error('Error updating company:', err);
          this.showErrorMessage(
            'Non è stato possibile aggiornare il prodotto.',
          );
        },
      });
    }
  }

  onCancel(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/savedproducts_table`]);
  }

  private showSuccessMessage(message: string): void {
    // const snackBarRef = this.snackBar.open(message, 'Close', {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
